import { navigate } from 'gatsby';
import { useDocumentState } from './documentState';

export const useDocument = (requiresSubscription, id) => {
  const documentState = useDocumentState(requiresSubscription, id);

  const handleSubscibeOrBuyClick = (id, gotToDocument = () => {}) => {
    switch (documentState) {
      case 'Buy':
        gotToDocument();
        break;
      case 'Purchased':
        navigate('/profile');
        break;
      case 'Open':
        navigate(`/embeded?id=${id}`);
        break;
      default:
        navigate('/cart');
        break;
    }
  };

  return {
    handleSubscibeOrBuyClick,
  };
};
